// booking/components/FormRadioGroup.jsx
import React, { memo } from 'react';
import { FormControl, RadioGroup, FormControlLabel, Radio, Typography, FormHelperText } from '@mui/material';

const FormRadioGroup = memo(
  ({
    name,
    formik,
    background,
    options = [
      { value: 'sr', label: 'Sr.' },
      { value: 'sra', label: 'Sra.' },
    ],
    error,
    helperText,
    ...props
  }) => (
    <FormControl error={error}>
      <RadioGroup
        row
        name={name}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        {...props}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                sx={{
                  '&.Mui-checked': {
                    color: background,
                  },
                }}
              />
            }
            label={<Typography fontSize="0.875rem">{option.label}</Typography>}
          />
        ))}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  ),
);

FormRadioGroup.displayName = 'FormRadioGroup';

export default FormRadioGroup;
